export * from './routes';
export * from './generate-path';
export * from './match-route';
import { SafeNavigateProvider } from './safe-navigate';
import { NavigationHistoryProvider } from './navigation-history';

export function RouterProvider({ children }: { children: React.ReactNode }) {
  return (
    <SafeNavigateProvider>
      <NavigationHistoryProvider>{children}</NavigationHistoryProvider>
    </SafeNavigateProvider>
  );
}
